module.exports = __webpack_public_path__ + "img/licenses.aef2fe32.svg";